import React, { useEffect, useState } from "react";
import {
  Link,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import ShowcaseView from "@/components/ShowcaseView";
import {
  itemParamOf,
  showcaseViewProps,
  useShowcaseFeed,
} from "@/pages/embed/ShowcaseEmbed";
import "./ShowcaseHostedPage.scss";

export const searchWithoutItem = (search) => {
  const next = new URLSearchParams(search);
  next.delete("item");
  // Used once, or meant for the buyer the link opened, so neither follows the visitor to the next card.
  next.delete("confirm");
  next.delete("contact");
  const text = next.toString();
  return text ? `?${text}` : "";
};

export const feedBaseOf = (pathname, item) => {
  const path = String(pathname || "").replace(/\/+$/, "");
  return item ? path.replace(/\/[^/]+$/, "") : path;
};

const ShowcaseHostedPage = ({ owner = "brokerage" }) => {
  const { slug, item } = useParams();
  const [params] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const base = feedBaseOf(location.pathname, item);
  const feed = useShowcaseFeed({
    slug,
    owner,
    initialOpenId: itemParamOf(params, item),
  });
  const urlItem = itemParamOf(params, item);
  const { setOpenId } = feed;

  useEffect(() => {
    setOpenId(urlItem);
  }, [urlItem, setOpenId]);
  const [confirmToken, setConfirmToken] = useState(
    () => new URLSearchParams(window.location.search).get("confirm") || "",
  );
  const clearConfirm = () => {
    setConfirmToken("");
    const url = new URL(window.location.href);
    url.searchParams.delete("confirm");
    window.history.replaceState(
      window.history.state,
      "",
      `${url.pathname}${url.search}${url.hash}`,
    );
  };
  const name = feed.first?.owner?.name || feed.first?.brokerage?.name;
  const unavailable =
    feed.query.isError || (feed.first && feed.first.live === false);

  useEffect(() => {
    if (name) document.title = `Buyers we are working with | ${name}`;
  }, [name]);

  return (
    <main className="showcase-hosted">
      {unavailable ? (
        <div className="showcase-hosted__gone">
          <h1>This page is not available right&nbsp;now</h1>
          <p>
            {owner === "agent"
              ? "The agent may have paused it."
              : "The brokerage may have paused it."}{" "}
            Browse local agents and their buyers in the agent&nbsp;directory.
          </p>
          <Link className="showcase-hosted__link" to="/agents">
            Open the agent directory
          </Link>
        </div>
      ) : (
        <ShowcaseView
          {...showcaseViewProps(feed)}
          onOpenChange={(id) => {
            const cameFromList = Boolean(location.state?.fromFeed);
            if (!id && cameFromList) {
              // The list is the previous entry: go back to it so Back leaves the page.
              navigate(-1);
              return;
            }
            const onList = !item && !params.get("item");
            navigate(`${id ? `${base}/${id}` : base}${searchWithoutItem(location.search)}`, {
              replace: !id || !onList,
              state: id ? { fromFeed: cameFromList || onList } : undefined,
            });
            if (id) window.scrollTo?.({ top: 0 });
          }}
          stickyContact
          autoContact={params.get("contact") === "1"}
          confirmToken={confirmToken}
          onConfirmHandled={clearConfirm}
        />
      )}
    </main>
  );
};

export default ShowcaseHostedPage;
